import { useState } from 'react';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';

const GiftCardMessage = (props) => {
  const [showMessage, setShowMessage] = useState(false);
  const { giftMessage } = props;

  const onCloseModal = () => {
    setShowMessage(false);
  };

  const onOpenModal = (e) => {
    e.preventDefault();
    setShowMessage(true);
  };

  if (!giftMessage || giftMessage.trim() === '') {
    return null;
  }

  return (
    <>
      <a href="" onClick={onOpenModal}>
        View Gift Message
      </a>
      <br />
      {showMessage && (
        <Modal title="Gift Message" onCloseModal={onCloseModal}>
          {giftMessage}
        </Modal>
      )}
    </>
  );
};

export default GiftCardMessage;
